<template>

  <div v-if="sharers">
    <table class="el-table">
      <thead>
        <tr>
          <th>#</th>
          <th width="25%">Sharer</th>
          <th>Site ID</th>
          <th>Billing From</th>
          <th>Frequency</th>
          <th>Own Meter?</th>
          <th v-if="canAccess('finance')">Deposit</th>
          <th v-if="canAccess('finance')">Std. Rate</th>
          <th v-if="canAccess('finance')" align="right">Outstanding</th>
        </tr>
      </thead>
      <tfoot>
      </tfoot>
      <tbody>
        <tr v-for="(telco, index) in sharers" :key="telco.id">
          <th>{{index+1}}</th>
          <td>{{telco.organisation.name}}</td>
          <td>{{telco.telcoSiteId}}</td>
          <td>{{formatDate(telco.utilityBillingStart)}}</td>
          <td>{{telco.utilityFrequency}}</td>
          <td>{{formatBoolean(telco.ownMeter)}}</td>
          <td v-if="canAccess('finance')">{{formatMoney(telco.utilityDeposit)}}</td>
          <td v-if="canAccess('finance')">{{formatMoney(telco.utilityStandardRate)}}</td>
          <td v-if="canAccess('finance')">{{formatMoney(0)}}</td>  <!-- TODO Fill in amount -->
        </tr>
      </tbody>
    </table>
    <br>
  </div>
  <div v-else>
    <h3>No licensees found</h3>
  </div>

</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {

  mixins: [DateMixins, NumberMixins],

  props: {
    sharers: {
      type: Array,
      required: true
    }
  },


  watch: {
    sharers: function (sharers) {
      this.sharers = sharers
      console.log('util sharers', this.sharers)
    }
  }
}

</script>
